import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup } from 'reactstrap';
import TextInput from '../common/controls/textInput';
const AssetComments = props => {
  const assetActions = props.assetActions,
    _props$asset = props.asset,
    assetID = _props$asset.id,
    comments = _props$asset.comments;
  const handleChange = (field, value) => assetActions.change(assetID, 'comments', value);
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "General Comments"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(TextInput, {
    className: "t-ac-comments",
    type: "textarea",
    value: comments || '',
    onChange: handleChange,
    style: {
      minHeight: '110px',
      height: '110px',
      resize: 'vertical'
    }
  })));
};
AssetComments.propTypes = {
  assetActions: PropTypes.shape({
    change: PropTypes.func.isRequired
  }).isRequired,
  asset: PropTypes.shape({
    comments: PropTypes.string,
    id: PropTypes.string
  }).isRequired
};
export default AssetComments;